<template>
  <div class="cantact" style="margin-top: -56px;">
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>

<style lang="less">
  .cantact{

  }
</style>





